module.exports = __webpack_public_path__ + "img/lescalestudio.82d298fc.jpg";